import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/tabbar/style/index.js
// module id = 216
// module chunks = 7